// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
    /**
     * Maintain a map of listener
     * lists, keyed by event name.
     *
     * @type Object
     */
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
  
    /** @type function() */
    this.handle = Delegate.prototype.handle.bind(this);
  
    // Cache of event listeners removed during an event cycle
    this._removedListeners = [];
  }
  
  /**
   * Start listening for events
   * on the provided DOM element
   *
   * @param  {Node|string} [root] The root node or a selector string matching the root node
   * @returns {Delegate} This method is chainable
   */
  Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;
  
    // Remove master event listeners
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
  
    // If no root or root is not
    // a dom node, then remove internal
    // root reference and exit here
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
  
    /**
     * The root node at which
     * listeners are attached.
     *
     * @type Node
     */
    this.rootElement = root;
  
    // Set up master event listeners
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        // Add the 'passive' option for scroll events
        const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
        this.rootElement.addEventListener(eventType, this.handle, {
          capture: true,
          passive: isScrollEvent,
        });
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        // Add the 'passive' option for scroll events
        const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
        this.rootElement.addEventListener(eventType, this.handle, {
          capture: false,
          passive: isScrollEvent,
        });
      }
    }
  
    return this;
  };
  
  /**
   * @param {string} eventType
   * @returns boolean
   */
  Delegate.prototype.captureForType = function (eventType) {
    return (
      ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
        eventType
      ) !== -1
    );
  };
  
  /**
   * Attach a handler to one
   * event for all elements
   * that match the selector,
   * now or in the future
   *
   * The handler function receives
   * three arguments: the DOM event
   * object, the node that matched
   * the selector while the event
   * was bubbling and a reference
   * to itself. Within the handler,
   * 'this' is equal to the second
   * argument.
   *
   * The node that actually received
   * the event can be accessed via
   * 'event.target'.
   *
   * @param {string} eventType Listen for these events
   * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
   * @param {function()} handler Handler function - event data passed here will be in event.data
   * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
   * @returns {Delegate} This method is chainable
   */
  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
  
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
  
    // handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
  
    // Fallback to sensible defaults
    // if useCapture not set
    if (useCapture === undefined) {
      useCapture = this.captureForType(eventType);
    }
  
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
  
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    const isScrollEvent =
      ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
      -1;
  
    // Add master handler for type if not created yet
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, {
          capture: useCapture,
          passive: isScrollEvent,
        });
      }
      listenerMap[eventType] = [];
    }
  
    if (!selector) {
      matcherParam = null;
  
      // COMPLEX - matchesRoot needs to have access to
      // this.rootElement, so bind the function to this.
      matcher = matchesRoot.bind(this);
  
      // Compile a matcher for the given selector
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
  
    // Add to the list of listeners
    listenerMap[eventType].push({
      selector: selector,
      handler: handler,
      matcher: matcher,
      matcherParam: matcherParam,
    });
  
    return this;
  };
  
  /**
   * Remove an event handler
   * for elements that match
   * the selector, forever
   *
   * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
   * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
   * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
   * @returns {Delegate} This method is chainable
   */
  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
  
    // Handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
  
    // If useCapture not set, remove
    // all event listeners
    if (useCapture === undefined) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
  
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
  
      return this;
    }
  
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
  
    // Remove only parameter matches
    // if specified
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
  
      if (
        (!selector || selector === listener.selector) &&
        (!handler || handler === listener.handler)
      ) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
  
    // All listeners removed
    if (!listenerList.length) {
      delete listenerMap[eventType];
  
      // Remove the main handler
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
  
    return this;
  };
  
  /**
   * Handle an arbitrary event.
   *
   * @param {Event} event
   */
  Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
  
    if (event[eventIgnore] === true) {
      return;
    }
  
    target = event.target;
  
    // Hardcode value of Node.TEXT_NODE
    // as not defined in IE8
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
  
    // Handle SVG <use> elements in IE
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
  
    root = this.rootElement;
  
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  
    // eslint-disable-next-line default-case
    switch (phase) {
      case 1: //Event.CAPTURING_PHASE:
        listenerList = this.listenerMap[1][type];
        break;
      case 2: //Event.AT_TARGET:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3: //Event.BUBBLING_PHASE:
        listenerList = this.listenerMap[0][type];
        break;
    }
  
    let toFire = [];
  
    // Need to continuously check
    // that the specific list is
    // still populated in case one
    // of the callbacks actually
    // causes the list to be destroyed.
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
  
        // Bail from this loop if
        // the length changed and
        // no more listeners are
        // defined between i and l.
        if (!listener) {
          break;
        }
  
        if (
          target.tagName &&
          ["button", "input", "select", "textarea"].indexOf(
            target.tagName.toLowerCase()
          ) > -1 &&
          target.hasAttribute("disabled")
        ) {
          // Remove things that have previously fired
          toFire = [];
        }
        // Check for match and fire
        // the event if there's one
        //
        // TODO:MCG:20120117: Need a way
        // to check if event#stopImmediatePropagation
        // was called. If so, break both loops.
        else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
  
      // TODO:MCG:20120117: Need a way to
      // check if event#stopPropagation
      // was called. If so, break looping
      // through the DOM. Stop if the
      // delegation root has been reached
      if (target === root) {
        break;
      }
  
      l = listenerList.length;
  
      // Fall back to parentNode since SVG children have no parentElement in IE
      target = target.parentElement || target.parentNode;
  
      // Do not traverse up to document root when using parentNode, though
      if (target instanceof HTMLDocument) {
        break;
      }
    }
  
    let ret;
  
    for (i = 0; i < toFire.length; i++) {
      // Has it been removed during while the event function was fired
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
  
      // Stop propagation to subsequent
      // callbacks if the callback returned
      // false
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
  
    return ret;
  };
  
  /**
   * Fire a listener on a target.
   *
   * @param {Event} event
   * @param {Node} target
   * @param {Object} listener
   * @returns {boolean}
   */
  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  
  /**
   * Check whether an element
   * matches a tag selector.
   *
   * Tags are NOT case-sensitive,
   * except in XML (and XML-based
   * languages such as XHTML).
   *
   * @param {string} tagName The tag name to test against
   * @param {Element} element The element to test with
   * @returns boolean
   */
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  
  /**
   * Check whether an element
   * matches the root.
   *
   * @param {?String} selector In this case this is always passed through as null and not used
   * @param {Element} element The element to test with
   * @returns boolean
   */
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return (
        // Match the outer document (dispatched from document)
        element === document ||
        // The <html> element (dispatched from document.body or document.documentElement)
        element === document.documentElement ||
        // Or the window itself (dispatched from window)
        element === window
      );
    }
    return this.rootElement === element;
  }
  
  /**
   * Check whether the ID of
   * the element in 'this'
   * matches the given ID.
   *
   * IDs are case-sensitive.
   *
   * @param {string} id The ID to test against
   * @param {Element} element The element to test with
   * @returns boolean
   */
  function matchesId(id, element) {
    return id === element.id;
  }
  
  /**
   * Short hand for off()
   * and root(), ie both
   * with no parameters
   *
   * @return void
   */
  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };
   
  
class DomHelper {
    constructor() { }
    getSiblings(element, filter) {
        var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var siblings = [];
        var currentElement = element;

        // Do the previous first
        while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        if (includeSelf) {
            siblings.push(element);
        }

        // Then the next side
        currentElement = element;

        while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        return siblings;
    }

    nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
                items.push(nodeList[i]);
            }
        }

        return items;
    }
    outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);

        return width;
    }
    outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);

        return height;
    }
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}


/******** Swiper inicialization ********/
class CodiSwiper {
    constructor(element, additionalSwiper) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.element = element;
      this.thumb = additionalSwiper;
      this.initialConfig = JSON.parse(
        element.getAttribute("data-swiper-settings")
      );
  
      if (additionalSwiper) {
        this.initialConfigThumbs = JSON.parse(
          additionalSwiper.getAttribute("data-swiper-thumb-settings")
        );
      }
      this.options = options;
      this.build();
    }
  
    selectCell(index) {
      this.swiperElement.slideTo(index);
    }
  
    resize() {
      this.swiperElement.resize();
    }
  
    build() {
      var _this = this,
        configThumb = this.initialConfigThumbs;
        
      if (configThumb != null) {
        this.thumbSwiper = new Swiper(this.thumb, configThumb);
        this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
      }
  
      this.swiperElement = new Swiper(this.element, this.initialConfig);
      this.selectedIndex = this.swiperElement.activeIndex;
  
      this.swiperElement.on("slideChange", function () {
  
        _this.element.dispatchEvent(
          new CustomEvent("swiper:slide-changed", {
            bubbles: true,
            detail: {
              currentIndex: _this.swiperElement.activeIndex,
              element: _this.swiperElement.el[0],
            },
          })
        );
      });
  
  
    }
}
/******** Swiper inicialization ********/
  
/****** Swiper section ******/
class NewSwiper extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new CodiSwiper(this.carouselElement);
    }
}
customElements.define("swiper-component", NewSwiper);
/****** Swiper section ******/

/******** Banner ********/
class mainBanner extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new CodiSwiper(this.carouselElement);
  }
}
customElements.define("main-banner", mainBanner);
/******** Banner ********/

/********* Video **********/
class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    const pdp = this.element.dataset.product === "true";
    if (pdp) {
      this.delElem = new Delegate(this.element);
      this.bindPdpEvents();
    }

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {

        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {

      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );

    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  bindPdpEvents() {
    this.delElem.on("play:video", () => { console.log("yesyes"); this.videoPlayer.play(); });
    this.delElem.on("pause:video", () => { this.videoPlayer.pause() });
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {

    if (!this.element.getAttribute("loaded")) {

      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
        ? "video/vimeo"
        : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle",
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };
    this.host = host;
    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options['muted'] && host == 'vimeo') {
      this.videoPlayer.on('play', function () {

        _this.videoPlayer.muted("true");
      })
    }



    if (this.options["controls"]) {
      if (host == 'html5'){
      this.videoPlayer.on("touchstart", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }
  
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });}
      if(host == 'html5') return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }
  
        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }


  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
        
          if(this.options['muted'] || this.host == 'vimeo' || this.host == 'youtube'){
            this.videoPlayer.muted("true");
          }
        
      
          const checkIfPlaying = () => {
          
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

/********* Video (you also need responsive and loadScript) **********/


/****** Footer ******/
class footerDropdown extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.dropdowns = this.element.querySelectorAll("details");

      if(window.innerWidth > 749){
        this.dropdowns.forEach(dropdown => {
          dropdown.setAttribute("open", "")
        });
      } else {
        this.dropdowns.forEach(dropdown => {
          dropdown.removeAttribute("open")
        });
      }
      
  }

}
customElements.define("footer-dropdown", footerDropdown);


/*******Cart form submit********/

class submitForm extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.checkbox = this.element.querySelector("#cart-checkbox");
    this.cta = this.element.querySelector(".CartDrawer-Checkout");

    this.customMessageElement = document.querySelector('textarea[name="attributes[Poruka uz cveće]"]');
    this.deliveryDateElement = document.querySelector('input[name="attributes[Datum isporuke]"]');
    this.deliveryTimeElement = document.querySelector('select[name="attributes[Vreme isporuke]"]');

    this.checkboxChecked();
     
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "#CartDrawer-Checkout",
      this.submitForm.bind(this)
    );
  }

  submitForm(event){
    event.preventDefault();
    const isCheckboxChecked = this.checkbox && this.checkbox.checked;
    const isDeliveryDateFilled = this.deliveryDateElement && this.deliveryDateElement.value;
    const isDeliveryTimeFilled = this.deliveryTimeElement && this.deliveryTimeElement.value;
    const isCustomMessageFilled = this.customMessageElement && this.customMessageElement.value;

    const error = this.element.querySelector('.cta--error');

    if (!isDeliveryDateFilled || !isDeliveryTimeFilled || !isCustomMessageFilled) {
      error.style.display = 'flex';
    } else{
      window.location.href = "/checkout";
    }
  }

  checkboxChecked() {
    if (this.checkbox != null) {
      this.cta.style.opacity = "0.5";
      this.cta.style.pointerEvents = "none";

      this.checkbox.addEventListener("click", () => {
        this.checkFields(); 
      });
    }

    if (this.deliveryDateElement != null) {
      this.deliveryDateElement.addEventListener("change", () => {
        this.checkFields();
      });
    }

    if (this.deliveryTimeElement != null) {
      this.deliveryTimeElement.addEventListener("change", () => {
        this.checkFields(); 
      });
    }

    if (this.customMessageElement != null) {
      this.customMessageElement.addEventListener("input", () => {
        this.checkFields(); 
      });
    }
  }

  checkFields() {
    const isCheckboxChecked = this.checkbox && this.checkbox.checked;
    const isDeliveryDateFilled = this.deliveryDateElement && this.deliveryDateElement.value;
    const isDeliveryTimeFilled = this.deliveryTimeElement && this.deliveryTimeElement.value;
    const isCustomMessageFilled = this.customMessageElement && this.customMessageElement.value;

    const error = this.element.querySelector('.cta--error');
    
    if (this.deliveryDateElement != null) {
      if(this.deliveryDateElement.value == ''){
        this.deliveryDateElement.classList.add('error--border');
      } else {
        this.deliveryDateElement.classList.remove('error--border');
      }
      if (this.deliveryTimeElement.value == ''){
        this.deliveryTimeElement.classList.add('error--border');
      } else {
        this.deliveryTimeElement.classList.remove('error--border');
      }
      if (this.customMessageElement.value == ''){
        this.customMessageElement.classList.add('error--border');
      } else {
        this.customMessageElement.classList.remove('error--border');
      }
    } 
  
    if (isCheckboxChecked && isDeliveryDateFilled && isDeliveryTimeFilled && isCustomMessageFilled) {
      error.style.display = 'none';
    }

    if(isCheckboxChecked){
      this.cta.style.opacity = "1";
      this.cta.style.pointerEvents = "all";
    } else {
      this.cta.style.opacity = "0.5";
      this.cta.style.pointerEvents = "none";
    }
    
  }
}

customElements.define("submit-form", submitForm);
/*******Cart form submit********/

/****** Product page ******/
class ProductElement extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.domDelegate = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.carouselElement = this.element.querySelector(".mainSwiper");
      this.carouselElementThumbs = this.element.querySelector(
        ".thumbnailsSwiper"
      );

      this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
      );

      this.carousel = new CodiSwiper(
        this.carouselElement,
        this.carouselElementThumbs
      );
      if (window.innerWidth > 1024 && this.carouselElementThumbs){
        this.carouselElementThumbs.style.height = this.carouselElement.clientHeight + 'px';
      }

      this.bindEvents();  
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      "[data-action='change-image']",
      this.updateImage.bind(this)
    );
  }

  updateImage(event) {
    const targetElement = event.target.closest('label[data-action="change-image"]');
   
    const selectedVariantId = targetElement.dataset.variantId;
    const selectedMediaId = targetElement.dataset.mediaId;
    
    if (!selectedVariantId) {
      return;
    }

    if (selectedMediaId) {
      const newSlide = document.querySelector(`[data-media-id="${selectedMediaId}"]`);
      if (newSlide) {
        const slideIndex = newSlide.getAttribute('data-swiper-slide-index');
        this.carousel.selectCell(parseInt(slideIndex, 10)); 
      }
      
    }

  }
}
customElements.define("product-element", ProductElement);
/****** Product page ******/

/******** Products recommendations **********/
class ProductsRecommendations extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      //const handleIntersection = (entries, observer) => {
        //if (!entries[0].isIntersecting) return;
        //observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('products-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              new CodiSwiper(this.querySelector('.swiper'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      //}
      //new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '-100px 0px 200px 0px' }).observe(this);
  }

}
customElements.define("products-recommendations", ProductsRecommendations);

/******** Products recommendations **********/

/******** Complementary products **********/
class complementaryProducts extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.domDelegate = new Delegate(this.element);
      this.delegateBody = new Delegate(document.body);
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new CodiSwiper(this.carouselElement);
      this.addToCartButton = document.querySelector('[data-type="add-to-cart-form"] .product-form__submit');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.overlayElement = document.querySelector('#CartDrawer-Overlay');

      if (!this.addToCartButton) return;

      this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      "[data-action='add-attribute']",
      this.addAtribute.bind(this)
    );
    this.delegateBody.on(
      "click",
      "[data-action='add-all']",
      this.addToCartAll.bind(this)
    );
    this.delegateBody.on(
      "click",
      "#CartDrawer-Overlay",
      this.closeDrawer.bind(this)
    );
  }

  addAtribute(){
    const selectedProducts = Array.from(document.querySelectorAll('.complementary-product-checkbox:checked'));
    if (selectedProducts.length > 0) {
      this.addToCartButton.setAttribute('data-action', 'add-all');
    } else {
      this.addToCartButton.removeAttribute('data-action');
    }
  }

  addToCartAll(event) {
    console.log('Dodaj sve');
    event.preventDefault(); 

    const selectedProducts = Array.from(document.querySelectorAll('.complementary-product-checkbox:checked'));

    const complementaryItems = selectedProducts.map(checkbox => ({
        id: checkbox.dataset.variantId,
        quantity: 1
    }));

    const mainProductId = this.addToCartButton.closest('form').querySelector('input[name="id"]').value;
    complementaryItems.unshift({ id: mainProductId, quantity: 1 });

    const addToCart = async () => {
      try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items: complementaryItems }) 
        });

        if (!response.ok) {
            throw new Error('Greška pri dodavanju proizvoda u korpu');
        }
        this.rerenderCart();
                  
      } catch (error) {
          console.error('Greška:', error);
      }
    };

    addToCart();
    
  }

  async rerenderCart(lineNumber, quantityChange){
    console.log('rerender');
    try {
      const response = await fetch(
        window.routes.localeRootUrl + "?section_id=cart-drawer",
        {
          credentials: "same-origin",
          method: "GET",
        }
      );
      const html = await response.text();
      this.replaceContent(html, lineNumber, quantityChange);

      setTimeout(() => {
        this.ensureDrawerIsReady(); 
      }, 200);

      this.updateCartIcon();
  
    } catch (error) {
      console.error("Error rendering cart:", error);
    }

  }

  ensureDrawerIsReady() {
    const cartDrawer = document.querySelector('cart-drawer');
    const focusableElements = cartDrawer.querySelectorAll('a, button, input');
    if (focusableElements.length > 0) {
      this.openDrawer();  
    } else {
      console.warn('Drawer content not ready, skipping trapFocus.');
    }
  }
  

  replaceContent(html, lineNumber, quantityChange){
    this.tempElement = document.createElement("div");
    this.tempElement.innerHTML = html;
    const cartContent = document.querySelector('cart-drawer');
    const newCartContent = this.tempElement.querySelector('cart-drawer');
    
    if (cartContent && newCartContent) {
      cartContent.innerHTML = newCartContent.innerHTML;
    }
    cartContent.classList.remove('is-empty');
  }

  openDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      console.warn('Drawer element not found or open method is missing.');
    }
  }

  closeDrawer(){
    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.close();
  }
  
  updateCartIcon() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        const cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
        const iconSvgWrapper = cartIconBubble.querySelector('.svg-wrapper');
  
        if (cart.item_count > 0) {
          if (!cartCountBubble) {
            const newBubble = document.createElement('div');
            newBubble.classList.add('cart-count-bubble');
            newBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>
            <span class="visually-hidden">${cart.item_count} items</span>`;
            cartIconBubble.appendChild(newBubble);
          } else {
            cartCountBubble.querySelector('span[aria-hidden="true"]').innerText = cart.item_count;
          }
  
          iconSvgWrapper.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"/></svg>';
        } else {
          if (cartCountBubble) {
            cartCountBubble.remove();
          }
  
          iconSvgWrapper.innerHTML = "{{'icon-cart-empty.svg' | inline_asset_content }}";
        }
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
      });
  }
  
 
}
customElements.define("complementary-products", complementaryProducts);

/******** Complementary products **********/

/******** Recently viewed products **********/
class recentlyViewed extends HTMLElement{
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.carouselElement = this.element.querySelector(".recently-swiper");
    this.carousel = new CodiSwiper(this.carouselElement);
    
    this.handleRecentlyViewed();
    
  }

  handleRecentlyViewed(){
    const productData = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
    const swiperWrapper = document.getElementById('recently-swiper-wrapper');

    if (productData.length === 0 || !swiperWrapper) return; // Ako nema proizvoda

    const validateProductUrl = async (url) => {
        try {
            const response = await fetch(url, { method: 'HEAD' }); // Proveravamo samo HEAD (brže)
            return response.ok; // true ako URL nije 404 ili druga greška
        } catch (error) {
            console.error('Greška prilikom validacije URL-a ${url}:, error');
            return false;
        }
    };

    const fetchProductHtml = async (product) => {
        const productUrl = `${window.location.origin}${product.productUrl}`;
        // Validiramo URL pre nego što pokušamo da učitamo HTML
        const isValid = await validateProductUrl(productUrl);
        if (!isValid) {
            console.warn(`Proizvod sa URL-om ${product.productUrl} nije dostupan. Preskačem.`);
            removeInvalidProduct(product.productId);
            return ''; // Preskačemo proizvod
        }

        try {
            const url = `${window.location.origin}${product.productUrl}?section_id=card-product`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch product HTML');
            }

            const htmlText = await response.text();
            
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlText;

            const cardProductHtml = tempDiv.querySelector('.product-card-wrapper');
            if (!cardProductHtml) {
                throw new Error('card-product section not found');
            }

            return cardProductHtml.outerHTML;
        } catch (error) {
            console.error(error);
            return '';
        }
    };

    const removeInvalidProduct = (productId) => {
        const updatedProducts = productData.filter(p => p.productId !== productId);
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    };

    const addSlidesToSwiper = async () => {
        for (const product of productData) {
          const slideHtml = await fetchProductHtml(product);
          if (slideHtml) {
              const slideElement = document.createElement('div');
              slideElement.classList.add('swiper-slide');
              slideElement.innerHTML = slideHtml;
              swiperWrapper.appendChild(slideElement);
          }
        }        
    };
    addSlidesToSwiper();

    new CodiSwiper(this.querySelector('.swiper'));
  }
}
customElements.define("recently-viewed", recentlyViewed);
/******** Recently viewed products **********/


/******** Newseltter popup **********/
class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else if (this.options['page_popup'] == true){
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
      //this.openNewsletter();
    }
  }

  handleOpenOptions() {
    const sessionKey = sessionStorage.getItem("popup-seen");
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (sessionKey !== "true") {
      if (this.options.scroll_amount > 0) {
        document.addEventListener("scroll", this.scrollListener.bind(this));
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener() {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  }

  openNewsletter() {
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
     // bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener(
        "click",
        this.closeNewsletter.bind(this)
      );

      sessionStorage.setItem("popup-seen", true);
      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter.bind(this)
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter() {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    //bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener(
      "click",
      this.closeNewsletter.bind(this)
    );

    document.removeEventListener("scroll", this.scrollListener.bind(this));
  }
}
customElements.define("newsletter-popup", NewsletterPopup);

/******** Newseltter popup **********/